module.exports = __webpack_public_path__ + "img/submit-hen.2a5411f2.png";